import current from '@/project/current';
import { getAllPages } from '@/utils';

export const LOGIN_STRATEGY_MAP = {
  DEFAULT_NO_NEED_LOGIN: 0, // 黑名单策略，默认可以进入APP
  DEFAULT_NEED_LOGIN: 1, // 白名单策略，默认不可以进入APP，需要强制登录
};
// 登录策略按项目模式决定：工作台模式（m_ios 包）强制登录（白名单策略，
// 未登录只能进免登录清单页）；其余项目模式默认无需登录（黑名单策略）
export const LOGIN_STRATEGY = current.mode === 'workbench'
  ? LOGIN_STRATEGY_MAP.DEFAULT_NEED_LOGIN
  : LOGIN_STRATEGY_MAP.DEFAULT_NO_NEED_LOGIN;
export const isNeedLoginMode = LOGIN_STRATEGY === LOGIN_STRATEGY_MAP.DEFAULT_NEED_LOGIN;

export const LOGIN_PAGE = '/pages/auth/login';
export const REGISTER_PAGE = '/pages/auth/register';
export const FORGET_PASSWORD_PAGE = '/pages/auth/forget-password';

export const LOGIN_PAGE_LIST = [LOGIN_PAGE, REGISTER_PAGE, FORGET_PASSWORD_PAGE];

// 在 definePage 里面配置了 excludeLoginPath 的页面，功能与 EXCLUDE_LOGIN_PATH_LIST 相同
export const excludeLoginPathList = getAllPages('excludeLoginPath').map(page => page.path);

// 排除在外的列表，白名单策略指白名单列表，黑名单策略指黑名单列表
// 白名单策略（工作台模式）：tabbar 与内容页全部强制登录，仅登录闭环与启动/错误兜底页免登录；
// 黑名单策略（其余模式）：此清单为空，需要登录的页面用 definePage needLogin/excludeLoginPath 声明
export const EXCLUDE_LOGIN_PATH_LIST = [
  ...(isNeedLoginMode ? [...LOGIN_PAGE_LIST, '/pages/index/index', '/pages/error/404'] : []),
  ...excludeLoginPathList, // 都是以 / 开头的 path
];

// 在小程序里面是否使用H5的登录页，默认为 false
// 如果为 true 则复用 h5 的登录逻辑
// TODO: 3/3 确定自己的登录页是否需要在小程序里面使用
export const LOGIN_PAGE_ENABLE_IN_MP = false;

/** 兼容 Vue2 旧路由映射表：Vue2 旧路径 -> Vue3 新路径 */
export const OLD_ROUTE_MAP: Record<string, string> = {
  '/pages/account/login/password': '/pages/auth/login',
  '/pages/account/login/message': '/pages/auth/login',
  '/pages/account/register/register': '/pages/auth/register',
  '/pages/me/login': 'pages/auth/register',
  '/pages/common/error/pay': '/pages/common/pay-error',
  // 工厂专区：统一跳转路径 /page/factory（站点菜单/深链均走此路径），映射到真实页面；
  // /factory 为历史菜单配置兼容保留，防止旧配置下发的短路径跳转失败
  '/page/factory': '/pages/factory/factory',
  '/factory': '/pages/factory/factory',
  // 国际专线：站点菜单短路径，映射到真实页面
  '/intl-line': '/pages/logistics/intl-line/intl-line',
};

/** iOS（工作台模式）不提供上货功能：兜底提示文案 */
export const UPLOAD_DISABLED_TIP = '请使用电脑端上传';

/**
 * 上货相关路由前缀：工作台/iOS 包命中后统一提示并阻断（见 src/router/interceptor.ts）。
 * 页面本体已不打包、上货通知已过滤（见 vite.config.ts PAGES_EXCLUDE），此处为纯防呆兜底（陈旧链接/误加入口）
 * 覆盖：上货管理（记录/任务/详情）、各平台上货表单、店铺上货配置、每日优选（自动上货）
 */
export const UPLOAD_DISABLED_PATH_PREFIXES = [
  '/pages/platform/upload-manager/',
  '/pages/platform/upload/',
  '/pages/platform/shop-list/upload-config',
  '/pages/platform/shop-list/auto-task',
];
